export const convertMillisToSeconds = (millis: number): number => millis / 1000;
export const convertSecondsToMinutes = (seconds: number): number =>
  Math.floor(seconds / 60);
